import { StatusBehaviours, GatewayState } from '../models/common';
import { MaintenanceLevel, AlertLevel, MessageLevel, AlertStatus, ErrorLevel, HomecareLevel, ColorIntensity } from './enums';
import { retry } from 'rxjs/operators';


export class colorutils {

  public static Default = "#2D6C9B";// "#009DA0";
  public static DefaultLite = "#8FD5C0";
  public static Red: string = "#AA0000";
  public static RedUnk: string = "#F49FA3"; //new red unknown
  public static RedOut: string = "#EB656A"; //new red out site
  // public static Orange: string = "#CC8800";
  public static Orange: string = "#FFA150"; //new orange reserved
  public static Yellow: string = "#AA8800";
  public static Green: string = "#00AA00";
  public static GreenAv: string = "#90C182"; //new green available
  public static GreenUsed: string = "#C4D45C"; //new green used
  public static Cyan: string = "#00AAAA";
  public static Blue: string = "#0000AA";
  public static Gray: string = "#AAAAAA";
  public static Mauve: string = "#9E9EEF"; //new mauve in maintenance
  public static GrayTransit: string = "#D0BFA9"; //new gray in transit

  public static DefaultDark = "#2D6C9B";// "#009DA0";
  public static DefaultSelection = "#4691C7";
  public static DefaultLiteDark = "#8FD5C0";
  public static RedDark: string = "#EE0000";
  public static OrangeDark: string = "#FFBB00";
  public static YellowDark: string = "#EEBB00";
  public static GreenDark: string = "#00EE00";
  public static CyanDark: string = "#00EEEE";
  public static BlueDark: string = "#0000EE";
  public static GrayDark: string = "#EEEEEE";

  public static BlueLight: string = "#2749ff";


  public static RedSoft: string = "#FF7777";
  public static OrangeSoft: string = "#FFCC99";
  public static GreenSoft: string = "#BBEEAA";
  public static BlueSoft: string = "#66BBFF";
  public static GraySoft: string = "#CCCCCC";
  /*
    public static CssFilterRed: string = "saturate(2000%) hue-rotate(140deg) brightness(80%)";
    public static CssFilterOrange: string = "saturate(2000%) hue-rotate(180deg) brightness(100%)";
    public static CssFilterGreen: string = "saturate(2000%) hue-rotate(240deg) brightness(100%)";
    public static CssFilterBlue: string = "saturate(2000%) hue-rotate(0deg) brightness(80%)";
    public static CssFilterGray: string = "saturate(0%) hue-rotate(140deg) brightness(100%)";
    //using https://codepen.io/sosuke/pen/Pjoqqp
    public static CssFilterRed: string = "invert(8%) sepia(87%) saturate(6963%) hue-rotate(13deg) brightness(89%) contrast(115%)";
    public static CssFilterOrange: string = "invert(44%) sepia(84%) saturate(592%) hue-rotate(14deg) brightness(99%) contrast(101%)";
    public static CssFilterGreen: string = "invert(38%) sepia(88%) saturate(2562%) hue-rotate(96deg) brightness(100%) contrast(102%)";
    public static CssFilterBlue: string = "invert(10%) sepia(66%) saturate(5775%) hue-rotate(234deg) brightness(97%) contrast(119%)";
    public static CssFilterGray: string = "invert(80%) sepia(1%) saturate(1862%) hue-rotate(5deg) brightness(86%) contrast(94%)";
  */

  // #03B4F6
  public static CssFilterBlueWT: string = "invert(64%) sepia(26%) saturate(6269%) hue-rotate(159deg) brightness(96%) contrast(101%)"
  // #2D6C9B
  //public static CssFilterBlueWT: string = "invert(39%) sepia(18%) saturate(2388%) hue-rotate(166deg) brightness(85%) contrast(77%)"

  public static CssFilterRed: string = "invert(8%) sepia(87%) saturate(6963%) hue-rotate(13deg) brightness(70%) contrast(115%)";
  public static CssFilterOrange: string = "invert(38%) sepia(88%) saturate(2562%) hue-rotate(16deg) brightness(70%) contrast(102%)";
  public static CssFilterYellow: string = "invert(44%) sepia(84%) saturate(592%) hue-rotate(14deg) brightness(70%) contrast(101%)";
  public static CssFilterGreen: string = "invert(38%) sepia(88%) saturate(2562%) hue-rotate(96deg) brightness(70%) contrast(102%)";
  public static CssFilterCyan: string = "invert(10%) sepia(66%) saturate(5775%) hue-rotate(240deg) brightness(96%) contrast(119%)";
  public static CssFilterBlue: string = "invert(10%) sepia(66%) saturate(5775%) hue-rotate(234deg) brightness(70%) contrast(119%)";
  public static CssFilterGray: string = "invert(80%) sepia(1%) saturate(1862%) hue-rotate(5deg) brightness(42%) contrast(94%)";


  public static CssFilterBlueWhereit: string = "invert(41%) sepia(17%) saturate(1968%) hue-rotate(163deg) brightness(85%) contrast(86%)";
  public static CssFilterWhite: string = "invert(100%)"
  //public static CssFilterWhite :string= "invert(100%) sepia(11%) saturate(7493%) hue-rotate(279deg) brightness(123%) contrast(97%);"

  private static Colors: string[] = [
    "#44CC44", "#DD4444", "#DD8844", "#4444DD",
    "#DDDD44", "#44DD88", "#8844DD", "#44DDDD",
    "#88DD44", "#DD44DD", "#DD4488", "#4488DD",
  ];

  private static ChartColors: string[] = [
    "#66FF66", "#FF6666", "#6666FF", "#FFAA66",
    "#66FFAA", "#AA66FF", "#FFFF66", "#66FFFF",
    "#FF66FF", "#AAFF66", "#66AAFF", "#FF66AA",
  ];

  public static getCriticalColor(count: number, value: boolean) {
    return count ? (value ? colorutils.RedDark : colorutils.Orange) : colorutils.Green;
  }

  public static getCriticalColorSoft(count: number, value: boolean) {
    return count ? (value ? colorutils.RedSoft : colorutils.OrangeSoft) : colorutils.GreenSoft;
  }

  public static getMessageErrorClass(value: ErrorLevel) {
    switch (value) {
      case ErrorLevel.Error:
        return "msg-error";
      case ErrorLevel.Warning:
        return "msg-warn";
      case ErrorLevel.Ok:
        return "msg-ok";
      case ErrorLevel.Info:
        return "msg-info";
      default:
        return "msg-error";
    }
  }

  public static getButtonErrorClass(value: ErrorLevel) {
    switch (value) {
      case ErrorLevel.Error:
        return "btn-inv-error";
      case ErrorLevel.Warning:
        return "btn-inv-warn";
      case ErrorLevel.Ok:
        return "btn-inv-ok";
      case ErrorLevel.Info:
        return "btn-inv-info";
      default:
        return "btn-inv-error";
    }
  }

  public static getBooleanColor(value: boolean) {
    return value ? colorutils.Green : colorutils.RedDark;
  }

  public static getAlertColor(value: AlertLevel) {
    switch (value) {
      case AlertLevel.Info:
        return colorutils.BlueLight;
      case AlertLevel.Warning:
        return colorutils.Orange;
      case AlertLevel.Error:
        return colorutils.RedDark;
      default:
        return colorutils.Gray;
    }
  }

  public static getAlertStatusColor(value: AlertStatus) {
    switch (value) {
      case AlertStatus.InProgress:
        return colorutils.BlueLight;
      case AlertStatus.Closed:
        return colorutils.Gray;
      case AlertStatus.New:
        return colorutils.RedDark;
      default:
        return colorutils.Gray;
    }
  }

  public static getMessageColor(value: MessageLevel) {
    switch (value) {
      case MessageLevel.Info:
        return colorutils.BlueLight;
      case MessageLevel.Success:
        return colorutils.Green;
      case MessageLevel.Warning:
        return colorutils.Orange;
      case MessageLevel.Error:
        return colorutils.RedDark;
      default:
        return colorutils.Gray;
    }
  }

  public static getMessageColorSoft(value: MessageLevel) {
    switch (value) {
      case MessageLevel.Info:
        return colorutils.BlueSoft;
      case MessageLevel.Success:
        return colorutils.GreenSoft;
      case MessageLevel.Warning:
        return colorutils.OrangeSoft;
      case MessageLevel.Error:
        return colorutils.RedSoft;
      default:
        return colorutils.GraySoft;
    }
  }

  public static getMaintenanceColor(value: MaintenanceLevel) {
    switch (value) {
      case MaintenanceLevel.UpToDate:
        return colorutils.Green;
      case MaintenanceLevel.Forthcoming:
        return colorutils.Yellow;
      case MaintenanceLevel.Upcoming:
        return colorutils.Orange
      case MaintenanceLevel.OutOfDate:
        return colorutils.RedOut;
      case MaintenanceLevel.NoActivation:
        return colorutils.GrayTransit;
      case MaintenanceLevel.WrongMaintenance:
        return colorutils.Mauve;
      default:
        return colorutils.Gray;
    }
  }

  public static getHomecareColor(value: HomecareLevel) {
    switch (value) {
      case HomecareLevel.UpToDate:
        return colorutils.BlueSoft;
      case HomecareLevel.Forthcoming:
        return colorutils.Yellow;
      case HomecareLevel.Upcoming:
        return colorutils.Orange
      case HomecareLevel.OutOfDate:
        return colorutils.RedOut;
      case HomecareLevel.Unknow:
        return colorutils.GrayTransit;
      case HomecareLevel.Returned:
        return colorutils.GreenAv;
      default:
        return colorutils.Gray;
    }
  }

  public static getMaintenanceCssFilterColor(value: MaintenanceLevel) {
    switch (value) {
      case MaintenanceLevel.UpToDate.valueOf():
        return colorutils.CssFilterGreen;
      case MaintenanceLevel.Forthcoming:
        return colorutils.CssFilterYellow;
      case MaintenanceLevel.Upcoming:
        return colorutils.CssFilterOrange;
      case MaintenanceLevel.OutOfDate:
        return colorutils.CssFilterRed;
      case MaintenanceLevel.NoActivation:
        return colorutils.CssFilterGray;
      case MaintenanceLevel.WrongMaintenance:
        return colorutils.CssFilterBlue;
      default:
        return colorutils.CssFilterGray;
    }
  }

  public static getStatusColor(value: StatusBehaviours) {
    switch (value) {
      case StatusBehaviours.empty:
        return colorutils.Gray;
      case StatusBehaviours.available:
        return colorutils.GreenAv;
      case StatusBehaviours.used:
        return colorutils.Orange;
      case StatusBehaviours.outsite:
        return colorutils.RedOut;
      case StatusBehaviours.reserved:
        return colorutils.Yellow;
      case StatusBehaviours.transit:
        return colorutils.GrayTransit;
      case StatusBehaviours.maintenance:
        return colorutils.Mauve;
      case StatusBehaviours.Homecare:
        return colorutils.GrayTransit;
      default:
        return colorutils.Gray;
    }
  }

  public static getStatusCssFilterColor(value: StatusBehaviours) {
    if (!value)
      return colorutils.CssFilterGray;
    switch (value) {
      case StatusBehaviours.available:
        return colorutils.CssFilterGreen;
      case StatusBehaviours.used:
        return colorutils.CssFilterOrange;
      case StatusBehaviours.outsite:
        return colorutils.CssFilterRed;
      case StatusBehaviours.reserved:
        return colorutils.CssFilterYellow;
      case StatusBehaviours.transit:
        return colorutils.CssFilterCyan;
      case StatusBehaviours.maintenance:
        return colorutils.CssFilterBlue;
      case StatusBehaviours.Homecare:
        return colorutils.CssFilterCyan;
      default:
        return colorutils.CssFilterGray;
    }
  }

  public static getStateCssFilterColor(sensor_type, state) {
    if (sensor_type == "fixed")
      switch (state) {
        case "badFloor":
          return colorutils.CssFilterRed;
        case "precision":
          return colorutils.CssFilterRed;
        case "sensor":
          return colorutils.CssFilterGreen;
        default:
          return colorutils.CssFilterBlue;
      }
    if (sensor_type == "gateway") {
      if (!state)
        return colorutils.CssFilterBlue;
      switch (state) {
        case GatewayState.Unknow:
          return colorutils.CssFilterBlue;
        case GatewayState.Connected:
          return colorutils.CssFilterGreen;
        case GatewayState.Disconnected:
          return colorutils.CssFilterRed;
        case GatewayState.Received:
          return colorutils.CssFilterYellow;
        default:
          return colorutils.CssFilterGray;
      }
    }
    if (sensor_type == "temperature")
      return state < 22 ? colorutils.CssFilterRed : colorutils.CssFilterGreen;
    if (sensor_type == "humidity")
      return state < 22 ? colorutils.CssFilterRed : colorutils.CssFilterGreen;
    if (state == "Opened" || state == "Water present" || state == "Moving" || state == "Unknow")
      return colorutils.CssFilterRed;
    if (state == "Closed" || state == "No water"|| state == "Static")
      return colorutils.CssFilterGreen;
    return colorutils.CssFilterBlue;
  }

  public static getStateKey(sensor_type, state) {
    let detail = " ";
    if (sensor_type == "fixed")
      detail = state;
    else if (sensor_type == "gateway")
      detail = state ? state.toString() : "Unknow";
    else if (sensor_type == "temperature")
      detail = state < 22 ? "error" : "ok";
    else if (sensor_type == "humidity")
      detail = state < 22 ? "error" : "ok";
    else if (sensor_type == "movement")
      detail = state >= 1 ? "error" : "ok";
    else if (state == "Opened" || state == "Water present" || state == "Moving" || state == "Unknow")
      detail = "error";
    else if (state == "Closed" || state == "No water" || state == "Static")
      detail = "ok";
    detail = "Unknow";
    return sensor_type + "_" + detail;
  }


  public static getValueColor(value: number) {
    return (value > 0) ? colorutils.Green : (value == 0) ? colorutils.Blue : colorutils.Red;
  }


  public static getValueColorDarkTheme(value: number) {
    return (value > 0) ? colorutils.GreenDark : (value == 0) ? colorutils.BlueDark : colorutils.RedDark;
  }

  public static getValueArrow(value: number) {
    return (value > 0) ? "arrow-up" : (value == 0) ? "arrow-right" : "arrow-down";
  }

  /**
   * Gets the standard color for the given index
   * @param index the index of the color
   */
  public static getColor(index: number) {
    return colorutils.Colors[index % 12];
  }

  public static getChartColor(index: number) {
    return colorutils.ChartColors[index % 12];
  }

  // Hue colors
  public static HRed = 0;
  public static HYellow = 60;
  public static HGreen = 120;
  public static HTurquoise = 180;
  public static HBlue = 240;
  public static HPink = 300;
  public static getHuePercent(percent: number, start_hue: number = colorutils.HRed, end_hue: number = colorutils.HGreen, alpha: number = 1) {
    let a = percent; // / 100;
    let b = (end_hue - start_hue) * a;
    let c = b + start_hue;
    return 'hsla(' + c + ', 100%, 50%, alpha)';
  }

  public static getLigthPercent(percent: number, hue: number = colorutils.HGreen, start_light: number = 0, end_light: number = 1, alpha: number = 1) {
    let a = percent; // / 100,
    let b = (end_light - start_light) * a;
    let light = ((b + start_light) * 100) + "%";
    return 'hsla(' + hue + ', 50%, ' + light + ', ' + alpha + ')';
  }

  public static getPrecisionColor(error: number, transparency: number = 1) {
    // 20 => red
    // 0 => green
    let r = Math.min(Math.round(error * 100), 255);
    let g = Math.max(Math.round((15 - error) * 17), 0);

    return "rgba(" + r + ", " + g + ", 0, " + transparency + ")";
  }

  public static getPercentColor(percent: number, intensity: ColorIntensity = ColorIntensity.Hard) {
    let component = 200 - (percent * 200);
    let r = Math.min(Math.round(component), 200);
    let g = Math.max(Math.round(200 - component), 0);

    return "rgba(" + r + ", " + g + ", 0, " + (intensity == ColorIntensity.Soft ? 0.075 : intensity == ColorIntensity.Mid ? 0.5 : 1) + ")";
  }

  public static getRssiColor(rssi: number, intensity: ColorIntensity = ColorIntensity.Hard) {
    if (rssi == null)
      return "#eeeeee";
    return this.getPercentColor(((110 + rssi) * 10 / 8) / 100, intensity);
  }

  public static getBooleanSoftColor(value: boolean) {
    return this.getPercentColor(value ? 1 : 0, ColorIntensity.Soft);
  }

}